import keycloak from '../keycloak';

const BASE = process.env.REACT_APP_API_BASE_URL || '/api';

async function request(path, options = {}) {
  await keycloak.updateToken(30);
  const res = await fetch(`${BASE}${path}`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${keycloak.token}`,
    },
    ...options,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(err.error || res.statusText);
  }
  if (res.status === 204) return null;
  return res.json();
}

export const api = {
  stores: {
    list:        ()       => request('/stores'),
    billingInfo: (id)     => request(`/stores/${id}/billing-info`),
  },
  commissionModels: {
    list:   (storeId) => request(`/commission-models?store_id=${storeId}`),
    create: (data)     => request('/commission-models', { method: 'POST', body: JSON.stringify(data) }),
    delete: (id)       => request(`/commission-models/${id}`, { method: 'DELETE' }),
  },
  invoices: {
    list:    (storeId)                     => request(`/invoices?store_id=${storeId}`),
    preview: (storeId, periodFrom, periodTo) =>
      request(`/invoices/preview?store_id=${storeId}&period_from=${periodFrom}&period_to=${periodTo}`),
    create:  (data)                        => request('/invoices', { method: 'POST', body: JSON.stringify(data) }),
    downloadPdf: async (id, filename) => {
      await keycloak.updateToken(30);
      const res = await fetch(`${BASE}/invoices/${id}/pdf`, {
        headers: { Authorization: `Bearer ${keycloak.token}` },
      });
      if (!res.ok) throw new Error('PDF konnte nicht geladen werden');
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename || 'rechnung.pdf';
      a.click();
      URL.revokeObjectURL(url);
    },
  },
};
